import { Box, Divider, Typography } from '@mui/material';
import { AccordionContentDto } from '@act/shared/data-transfer-objects';
import AccordionEntry from './AccordionEntry';
import { Fragment } from 'react/jsx-runtime';
import { reemaColors } from '@act/storybook';

interface AccordionSectionProps {
  content: AccordionContentDto;
}

const AccordionSection = ({ content }: AccordionSectionProps) => {
  return (
    <Box component="div" sx={{ width: '100%', boxSizing: 'border-box' }}>
      {content.title && (
        <Box
          component="div"
          sx={{ padding: '12px 0 16px', boxSizing: 'border-box' }}
        >
          <Typography
            component="span"
            variant="subheadLarge"
            color={reemaColors.black}
          >
            {content.title}
          </Typography>
        </Box>
      )}
      {[...content.entries]
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map(entry => {
          return (
            <Fragment
              key={`accordion-entry-${entry.summary}${entry.sortOrder}`}
            >
              <AccordionEntry entry={entry} />
              <Divider sx={{ margin: '0' }} />
            </Fragment>
          );
        })}
    </Box>
  );
};

export default AccordionSection;
